import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
export function CTASection() {
  return <section className="w-full px-4 py-20 bg-cream" data-id="element-33">
      <div className="max-w-3xl mx-auto text-center" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-35">
          <h2 className="font-handwriting text-5xl md:text-6xl text-forest font-bold leading-tight" data-id="element-36">
            Schluss mit peinlichen Momenten – für dich und deinen Hund
          </h2>

          <p className="font-serif text-xl text-gray-700 leading-relaxed max-w-2xl mx-auto" data-id="element-37">
            Teste das Magen-Darm-Topping jetzt risikofrei – mit
            Geld-zurück-Garantie. Natürlich. Pflanzlich. Wirksam.
          </p>

          <div className="pt-4 pb-2" data-id="element-38">
            <a href="https://hunderunde.shop/products/futtertopping-magen-darm" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-forest hover:bg-forest-light text-white font-serif font-bold text-lg md:text-xl py-4 px-8 md:px-12 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-39">
              Jetzt für meinen Hund entdecken
              <ArrowRight className="w-6 h-6" data-id="element-40" />
            </a>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-sm font-serif text-gray-600" data-id="element-41">
            <div className="flex items-center gap-1" data-id="element-42">
              <Check className="w-4 h-4 text-forest" data-id="element-43" />
              <span data-id="element-44">Schneller Versand</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-45">
              <Check className="w-4 h-4 text-forest" data-id="element-46" />
              <span data-id="element-47">Zufriedenheitsgarantie</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-48">
              <Check className="w-4 h-4 text-forest" data-id="element-49" />
              <span data-id="element-50">100% Natürliche Inhaltsstoffe</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}